import { ContainerListItem } from './container-list-item';
import type { Container } from '@/types/container';

interface ContainerListViewProps {
    containers: Container[];
    onContainerSelect?: (containerId: string) => void;
    className?: string;
}

export const ContainerListView = ({
    containers,
    onContainerSelect,
    className
}: ContainerListViewProps) => {
    return (
        <div className={className}>
            <div className="space-y-4">
                {containers.map((container) => (
                    <ContainerListItem
                        key={container.id}
                        container={container}
                        onSelect={onContainerSelect}
                    />
                ))}
            </div>
            {containers.length === 0 && (
                <div className="text-center py-12">
                    <p className="text-tertiary">Nessun container disponibile</p>
                </div>
            )}
        </div>
    );
};

